import React from "react";
import "./input.scss";

// import info from '../../assets/info-circle-solid.svg'
import Tooltip from "../tooltip/tooltip";
import EyeOn from "../../assets/eye-outline.svg";
import EyeOff from "../../assets/eye-off-outline.svg";

import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import InputMask from "react-input-mask";

export default class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      passwordType: "password",
    };
  }

  passwordChange = () => {
    if (this.props.isPassword) {
      if (this.state.passwordType === "password") {
        this.setState({ passwordType: "text" });
      }

      if (this.state.passwordType === "text") {
        this.setState({ passwordType: "password" });
      }
    }
  };

  render() {
    const {
      tooltipText,
      // disabled,
      placeholder,
      name,
      type,
      // size,
      defaultValue,
      // inputStyle,
      // inputColor,
      autofocus,
      onInput,
      onFocus,
      onBlur,
      onKeyPress,
      onKeyUp,
      onKeyDown,
      onChange,
      maxlength,
      minlength,
      value,
      _onFocus,
      _onBlur,
      required,
      isPassword,
      money,
      mask,
    } = this.props;

    const defaultMaskOptions = {
      prefix: "R$ ",
      suffix: "",
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: true,
      decimalSymbol: ",",
      decimalLimit: 2, // how many digits allowed after the decimal
      integerLimit: 7, // limit length of integer numbers
      allowNegative: false,
      allowLeadingZeroes: false,
      requireDecimal: true,
    };

    const currencyMask = createNumberMask(defaultMaskOptions);

    return (
      <div className="input-container">
        {!money ? (
          mask ? (
            <InputMask
              mask={mask}
              value={value}
              defaultValue={defaultValue}
              onChange={onChange}
              onInput={onInput}
              onFocus={onFocus || _onFocus}
              onBlur={onBlur || _onBlur}
              onKeyPress={onKeyPress}
              onKeyUp={onKeyUp}
              onKeyDown={onKeyDown || null}
            >
              {(inputProps) => (
                <input
                  id={name}
                  ref={this.input}
                  name={name}
                  className="input"
                  type={isPassword ? this.state.passwordType : type}
                  pattern=".+"
                  value={value}
                  maxLength={maxlength}
                  minLength={minlength}
                  autoFocus={autofocus}
                  required={required || true}
                />
              )}
            </InputMask>
          ) : (
            <input
              id={name}
              ref={this.input}
              name={name}
              className="input"
              type={isPassword ? this.state.passwordType : type}
              pattern=".+"
              defaultValue={defaultValue}
              value={value}
              maxLength={maxlength}
              minLength={minlength}
              autoFocus={autofocus}
              onInput={onInput}
              onFocus={onFocus || _onFocus}
              onBlur={onBlur || _onBlur}
              onKeyPress={onKeyPress}
              onKeyUp={onKeyUp}
              onKeyDown={onKeyDown || null}
              onChange={onChange || null}
              required={required || true}
            />
          )
        ) : (
          <MaskedInput mask={currencyMask} {...this.props} />
        )}
        <label className="label" htmlFor={name}>
          {placeholder}
        </label>
        {tooltipText ? (
          <div text={tooltipText} className={"info"}>
            <Tooltip />
          </div>
        ) : null}
        {isPassword ? (
          <img
            onClick={this.passwordChange}
            src={this.state.passwordType === "password" ? EyeOn : EyeOff}
            className={"showPassword"}
            alt=""
          />
        ) : null}
      </div>
    );
  }
}
